import * as Sentry from '@sentry/react';

export const initSentry = () => {
  if (process.env.NODE_ENV === 'production') {
    Sentry.init({
      // routing to crypto-payins-frontend sentry project: https://sentry.corp.stripe.com/settings/stripe/projects/crypto-payins-frontend/
      dsn: 'https://66e09dc56b844d8590a748f8ad4431db@errors.stripe.com/1237',
      release: process.env.RELEASE_VERSION,
    });
  } else {
    Sentry.init({
      // routing to crypto-payins-frontend-dev sentry: https://sentry.corp.stripe.com/settings/stripe/projects/crypto-payins-frontend-dev/
      dsn: 'https://fc0b2ad507fe4334b90f0885b5482dca@errors.stripe.com/1239',
      release: process.env.RELEASE_VERSION,
    });
  }
};
